import { IS_DEV } from './constants';

export function getDefaultLobbyWsUrl(windowObj: Window = window): string {
  if (import.meta.env.VITE_LOBBY_WS_URL) {
    return import.meta.env.VITE_LOBBY_WS_URL;
  }

  const protocol = windowObj.location.protocol === 'https:' ? 'wss:' : 'ws:';

  if (IS_DEV) {
    return `${protocol}//localhost:8081/ws`;
  }

  return `${protocol}//${windowObj.location.host}/ws`;
}
